import "./outlinedPinkButton.scss";
import PropTypes from "prop-types";

function OutlinedPinkButton({
  onPressFunction,
  children,
  disabled = false,
  type = "button",
  className = "",
}) {
  return (
    <button
      type={type}
      className={`pinkOutlinedButton ${className}`.trim()}
      onClick={onPressFunction}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

OutlinedPinkButton.propTypes = {
  onPressFunction: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
};

export default OutlinedPinkButton;
